export default "__VITE_ASSET__CHVEHoM2__"